'use client';

import { useState } from 'react';
import { toast } from 'react-toastify';

import { useManageBlogsMutation } from '@/store/api/account';

export const useManageBlogs = () => {
  const [manageBlogs] = useManageBlogsMutation();
  const [isLoading, setIsLoading] = useState(false);

  const handleManageBlogsClick = async (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>,
    redirectUrl: string
  ) => {
    e.preventDefault();

    if (isLoading) return;

    setIsLoading(true);

    try {
      const response = await manageBlogs().unwrap();

      if (response.success) {
        window.location.href = redirectUrl;
      } else {
        toast.error(response.message || 'Failed to access blogs. Please try again.');
        setIsLoading(false);
      }
    } catch (error: any) {
      toast.error(error?.data?.message || 'An error occurred. Please try again.');
      setIsLoading(false);
    }
  };

  return { handleManageBlogsClick, isLoading };
};
